import script from "./ChatPricingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPricingModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatPricingModal.vue?vue&type=style&index=0&id=d0f4e4ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0f4e4ac"]])

export default __exports__